import React from 'react';
import './coachProfile.module.scss';

import { Coach } from '../../../types/coach';
import { observer } from 'mobx-react';
import { MarkdownText } from '../text/MarkdownText';
import facebookIcon from './images/sns-facebook.png';
import instagramIcon from './images/sns-insta.png';
import twitterIcon from './images/sns-twitter.png';
import { viewportState } from '../../../../commonv2/states/globalStates';

type Props = {
  coach: Coach;
};

const CoachSns = observer(({ coach }: Props) => (
  <div styleName="sns">
    {coach.twitter && (
      <a href={coach.twitter} styleName="icon">
        <img src={twitterIcon} styleName="sns-image" />
      </a>
    )}
    {coach.facebook && (
      <a href={coach.facebook} styleName="icon">
        <img src={facebookIcon} styleName="sns-image" />
      </a>
    )}
    {coach.instagram && (
      <a href={coach.instagram} styleName="icon">
        <img src={instagramIcon} styleName="sns-image" />
      </a>
    )}
  </div>
));

export const CoachProfile = observer(
  class CoachProfile extends React.Component<Props> {
    render() {
      const { coach } = this.props;
      return (
        <div styleName="container">
          <div styleName="header">
            <img styleName="profile-image" src={coach.profile_photo_url} />
            <div styleName="details-container">
              <div styleName="name">
                <p>{coach.name}</p>
                {!viewportState.isMobile && <CoachSns coach={coach} />}
              </div>
              <div styleName="title">{coach.title}</div>
              {viewportState.isMobile && <CoachSns coach={coach} />}
            </div>
          </div>
          <div styleName="description">
            <MarkdownText source={coach.profile} />
          </div>
        </div>
      );
    }
  }
);
